import React from "react";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import Tooltip from "@mui/material/Tooltip";

function AdjustmentsHistoryTooltip(props) {
  function convertTimestamp(timestamp) {
    // Create a Date object from the timestamp.
    const dateObj = new Date(timestamp);

    // Define options for formatting the date.
    const options = {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    };

    // Return the date formatted for en-US locale.
    return dateObj.toLocaleString("en-US", options);
  }

  // Calculate dollar differences
  function calculateDifference(currentValue, previousValue) {
    const difference = currentValue - previousValue;
    const formattedDifference = difference.toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });

    // Determine if it's an increase or decrease
    const isIncrease = difference > 0;
    const textColorClass = isIncrease ? "text-emerald-700" : "text-rose-700";
    const sign = isIncrease ? "+" : "";

    return {
      formattedDifference: `${sign}${formattedDifference}`,
      textColorClass,
    };
  }

  return (
    <Tooltip
      title={
        <div className="p-3 bg-white rounded-lg">
          <h3 className="font-medium text-sm text-slate-900 border-b pb-3 mb-2">
            Forecast Adjustment History
          </h3>
          {!props.internal &&
            <div className="flex space-x-2 mt-4">
              <div className="flex flex-col items-center">
                <div className="w-1.5 h-1.5 rounded-full bg-slate-400 mt-1"></div>
                <div className="w-[1px] bg-slate-200 flex-1 mt-1"></div>
              </div>
              <div className="flex-1 pb-4">
                <p className="text-slate-900">Rightwork Forecast</p>
                {/* <p className="text-slate-500 mt-1">3/11/25 11:00am</p> */}
              </div>
              <p className="text-slate-900">
                {props.initial_forecast?.toLocaleString("en-US", {
                  style: "currency",
                  currency: "USD",
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 0,
                })}
              </p>
            </div>
          }
          {props.adjustments_history?.map((adjustment, index) => {
            // Calculate difference based on index
            let previousValue =
              index === 0
                ? props.initial_forecast
                : props.adjustments_history[index - 1].sales_value;

            const { formattedDifference, textColorClass } = calculateDifference(
              adjustment.sales_value,
              previousValue
            );


            const isFirstItem = index === 0

            const isLastItem = index === props.adjustments_history.length - 1;

            return (
              <div key={index} className="flex space-x-2">
                <div className="flex flex-col items-center">
                  <div className="w-1.5 h-1.5 rounded-full bg-slate-400 mt-1"></div>
                  {!isLastItem && (
                    <div className="w-[1px] bg-slate-200 flex-1 mt-1"></div>
                  )}
                </div>
                <div className={`flex-1 ${!isLastItem ? "pb-4" : "pb-2"}`}>
                  <p className="text-slate-900">
                    {props.internal ? isFirstItem ? "Rightwork Initial" : "Rightwork Update" : "Manual Update"}
                  </p>
                  <p className="text-slate-500 mt-1">
                    {convertTimestamp(adjustment?.created_at)}
                  </p>
                  {adjustment?.reason && (
                    <p className="text-slate-600 text-xs mt-1">
                      <span className="font-medium">Reason:</span> {adjustment.reason}
                    </p>
                  )}
                  {adjustment?.note && (
                    <p className="text-slate-600 text-xs mt-1 italic">
                      "{adjustment.note}"
                    </p>
                  )}
                </div>
                <div>
                  <p className="text-slate-900 text-right">
                    {adjustment?.sales_value?.toLocaleString("en-US", {
                      style: "currency",
                      currency: "USD",
                      minimumFractionDigits: 0,
                      maximumFractionDigits: 0,
                    })}
                  </p>
                  {!(props.internal && isFirstItem) &&
                    <p className={`${textColorClass} text-right text-xxs mt-0.5`}>
                      {formattedDifference}
                    </p>
                  }
                </div>
              </div>
            );
          })}
        </div>
      }
      placement="top-end"
      classes={{
        tooltip: "bg-white text-black shadow-xl p-0 border border-slate-200",
      }}
      componentsProps={{
        tooltip: {
          sx: {
            bgcolor: "white",
            width: "320px",
            borderRadius: "8px",
          },
        },
      }}
    >
      <InfoOutlinedIcon
        style={{ fontSize: "16px", color: "#6d28d9", cursor: "pointer" }}
      />
    </Tooltip>
  );
}

export default AdjustmentsHistoryTooltip;
